export function isAuthProviderError(obj: unknown): obj is { description: string } {
  return !!obj && typeof obj === 'object' && 'description' in obj!;
}
